import { AnalyticsBrowser } from '@segment/analytics-next';

const noop = () => {};
const noopAnalytics = {
  track: noop,
  page: noop,
  identify: noop,
  then: (cb) => cb([noopAnalytics]),
};

const isBrowser = typeof window !== 'undefined';
const writeKey = process.env.GATSBY_SEGMENT_ID || process.env.SEGMENT_ID;

export const analytics =
  isBrowser && writeKey
    ? AnalyticsBrowser.load(
        { writeKey, cdnURL: 'https://sapi.quashed.co.nz/cdn' },
        {
          integrations: {
            'Segment.io': {
              apiHost: 'sapi.quashed.co.nz/v1',
              protocol: 'https',
            },
          },
        },
      )
    : noopAnalytics;

// Expose on window for any remaining direct window.analytics references
if (isBrowser) {
  analytics.then(([a]) => {
    window.analytics = a;
  });
}
